module.exports = __webpack_public_path__ + "img/remove-red-eye.ec06b5a6.svg";